/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ServiceOrderConfirmRequest } from '../types/ServiceOrderConfirm';
import type { ServiceOrderListResponse } from '../types/ServiceOrderList';

export type ServiceOrdersConfirmCreateRequest = ServiceOrderConfirmRequest;
export type ServiceOrdersConfirmCreateResponse = ServiceOrderListResponse;

export type ServiceOrdersConfirmCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this service order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/service_orders/{id}/confirm/
 *
 * ```yaml
 * operationId: service_orders_confirm_create
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderConfirm'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderConfirm'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderConfirm'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderList'
 *     description: ''
 * ```
 */
export const serviceOrdersConfirmCreateOperation = ({
  id,
  ...rest
}: ServiceOrdersConfirmCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/service_orders/${id}/confirm/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/service_orders/{id}/confirm/' };
  };

/**
 * POST /dmx-server/service_orders/{id}/confirm/
 *
 * ```yaml
 * operationId: service_orders_confirm_create
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderConfirm'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderConfirm'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderConfirm'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderList'
 *     description: ''
 * ```
 */
export const serviceOrdersConfirmCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ServiceOrdersConfirmCreateQuery;
  request: ServiceOrderConfirmRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ServiceOrderListResponse>> => {
  const operation = serviceOrdersConfirmCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
